import React from "react";
import {
  Box,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { setFormModal } from "../redux/slices/modalSlice";
import {registerEvents} from "../services/eventService";
import { setloadTost } from "../redux/slices/toastSlice";
import { initiateRemitaPayment } from "../services/paymentMethodService";
import { setMyDuesDetails } from "../redux/slices/myDuesSlice";
import { fetchUpcomingEvents } from "../redux/slices/eventSlice";

const StudentEventDetails = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const eventDetailsData = useSelector((state) => state?.event?.eventDetails);

  const list = [
    { title: "Description:", description: eventDetailsData?.description },
    {
      title: "Start Date:",
      description:
        eventDetailsData?.startDate &&
        format(new Date(eventDetailsData?.startDate), "yyyy-MM-dd"),
    },
    {
      title: "End Date:",
      description:
        eventDetailsData?.endDate &&
        format(new Date(eventDetailsData?.endDate), "yyyy-MM-dd"),
    },
    {
      title: "Registration Link:",
      description: eventDetailsData?.registrationLink,
    },
    { title: "Guest Speaker:", description: eventDetailsData?.guestSpeaker },
    { title: "Event Location:", description: eventDetailsData?.eventLocation },
    { title: "Status:", description: eventDetailsData?.status },
    { title: "Credit Point:", description: eventDetailsData?.creditPoint },
    { title: "Event Category:", description: eventDetailsData?.eventCategory },
    { title: "Amount:", description: eventDetailsData?.amount },
  ];

  // dispatch(setFormModal({ status: true, title: "Registration Form", type: "EventReg", size: "md" }));

  const handleRegisterEvent = async () => {
    setLoading(true);
    const res = await registerEvents(eventDetailsData?.id);

    if (res?.isSuccess === true) {
      const feePaymentId = res?.data?.feePaymentId;
  
      dispatch(setloadTost({ title: 'Successs', description: `Registered successfully`, status: 'success', duration: 5000, isClosable: true, position: 'top' }));

      if(eventDetailsData?.eventCategory === "Paid"){
        const response = await initiateRemitaPayment(feePaymentId);
  
        if (response?.isSuccess === true) {
          setLoading(false);
          dispatch(setMyDuesDetails(response));
          dispatch(setFormModal({ status: true, title:"Payment",  type: "memberProfilePayment", size: "3xl"}));
        }else{
          setLoading(false);
          dispatch(setloadTost({ title: 'Error', description: `${response?.response?.data?.error?.description || response?.error?.description ||  "Failed to initiate payment"} `, status: 'warning', duration: 5000, isClosable: true, position: 'top' }));
        }
      }else{
        setLoading(false);
        dispatch(setFormModal({ status: false, data: null }));
      }
      dispatch(fetchUpcomingEvents('upcoming'))
    }else{
      setLoading(false);
      dispatch(setloadTost({ title: 'Failed', description: `${res?.payload?.errors?.map((errors) => errors) || res?.payload?.error?.description || "Failed to Register Event"}`, status: 'error', duration: 5000, isClosable: true, position: 'top' }));
    }
  }

  const handleMakePaymentEvent = async() => {
    setLoading(true);
    const feePaymentId = eventDetailsData?.eventPayment?.feePaymentId;
    const response = await initiateRemitaPayment(feePaymentId);

    if (response?.isSuccess === true) {
      setLoading(false);
      dispatch(setMyDuesDetails(response));
      dispatch(setFormModal({ status: true, title:"Payment",  type: "memberProfilePayment", size: "3xl"}));
    }else{
      setLoading(false);
      dispatch(setloadTost({ title: 'Error', description: `${response?.response?.data?.error?.description || "Failed to initiate payment"} `, status: 'warning', duration: 5000, isClosable: true, position: 'top' }));
    }
  }


  return (
    <>
      <Box bgColor={"white"} h={"100%"}>
        <Flex
          justifyContent={"flex-start"}
          pl={"50px"}
          alignItems={"center"}
          mx={"-24px"}
          h={"80px"}
          bgColor={"#812773"}
          mb={"30px"}
        >
          <Text
            color={"#FFFFFF"}
            fontSize={["18px", "20px", "24px"]}
            fontWeight={"600"}
            pl={["2px", null, null]}
          >
            {eventDetailsData?.eventName}
          </Text>
        </Flex>
        {list?.map((item, index) => (
          <Flex
            key={index}
            alignItems={"center"}
            px={["", "15px", "20px"]}
            pb={5}
            gap={["3", null, null]}
          >
            <Text
              color={"rgba(81, 81, 101, 0.5)"}
              fontSize={"16px"}
              fontWeight={700}
              w={["40%", "15%", "20%"]}
            >
              {item.title}
            </Text>
            <Text
              color={"rgba(0, 0, 0, 0.5)"}
              fontSize={"14px"}
              fontWeight={700}
              w={["60%", "85%", "80%"]}
            >
              {item.description}
            </Text>
          </Flex>
        ))}{" "}
      </Box>
      <Flex justifyContent={"left"} alignItems={"center"} gap={5}>
        <Button
          mt={10}
          fontSize={"16px"}
          fontWeight={"500"}
          lineHeight={"16px"}
          width={"200px"}
          background={"#A6A6A6"}
          _hover={{ background: " " }}
          color={"#FFFFFF"}
          onClick={() => {
            dispatch(setFormModal({ status: false, data: null }));
          }}
        >
          Cancel
        </Button>
        { eventDetailsData?.hasRegistered === false &&
        <Button
          mt={10}
          fontSize={"16px"}
          fontWeight={"500"}
          lineHeight={"16px"}
          width={"200px"}
          background={"#D11A2A"}
          _hover={{ background: " " }}
          color={"#FFFFFF"}
          type="submit"
          isLoading={loading}
          loadingText="Loading ..."
          onClick={() => handleRegisterEvent()}
        >
          Register For Event
        </Button>
        }
        {(eventDetailsData?.hasRegistered === true && eventDetailsData?.eventCategory === "Paid" && eventDetailsData?.eventPayment?.status !== "Paid") &&
        <Button
          mt={10}
          fontSize={"16px"}
          fontWeight={"500"}
          lineHeight={"16px"}
          width={"200px"}
          background={"#D11A2A"}
          _hover={{ background: " " }}
          color={"#FFFFFF"}
          type="submit"
          isLoading={loading}
          loadingText="Loading ..."
          onClick={() => handleMakePaymentEvent()}
        >
          Make Payment
        </Button>
        }
      </Flex>
    </>
  );
};

export default StudentEventDetails;
